import { SearchBarWidgetElement } from './define-search-bar-element';

export function registerSearchBarWidget() {
  if (typeof window === 'undefined') return;
  if (window.customElements.get('adipa-search-bar-widget')) return;

  window.customElements.define('adipa-search-bar-widget', SearchBarWidgetElement);
}
